import React from 'react';
import {observer} from 'mobx-react';
import {t} from 'shared/core';
import {FormattedMessage} from 'react-intl';
import {Panel} from 'components';
import {ReviewsList} from 'containers/employees/hire/components/steps/reviews/reviews_list';

const Title = observer(() => {
  return (
    <FormattedMessage
      id='employees.hire.reviews.ONBOARDING_REVIEWS_HEADER'
      values={{
        optional: <span className='waterloo'>{t('employees.hire.reviews.(Optional)')}</span>
      }}
    />
  );
});

const Reviews = observer(({uiState}) => {
  const {employee} = uiState;

  return (
    <div>
      <Panel.Header
        title={<Title/>}
        description={<FormattedMessage id='employees.hire.reviews.REVIEWS_DESC' values={{employee: employee.name}}/>}
      />
      <ReviewsList
        onChange={(reviewCycles) => uiState.setSelectedReviews(reviewCycles)}
        employee={uiState.employee}
        reviewCycles={uiState.reviewCycles}
      />
    </div>
  );
});

export default Reviews;
